import { AppLayout } from './Layout/Layout';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import React from 'react';

interface AppProps extends WithTranslation {}

const App = (props: AppProps) => {
  return <AppLayout />;
};

export default withTranslation()(App);
